import type { HTMLAttributes, ReactNode } from 'react';
import { cx } from './cx';

interface CardProps extends HTMLAttributes<HTMLDivElement> {
  /** Removes padding and gap — for cards whose only child is a table. */
  flush?: boolean;
  children: ReactNode;
}

export function Card({ flush, className, children, ...rest }: CardProps) {
  return (
    <div className={cx('card', flush && 'card-flush', className)} {...rest}>
      {children}
    </div>
  );
}

interface CardHeaderProps {
  title: ReactNode;
  sub?: ReactNode;
  /** Right-hand slot: a "view all" link, a badge, a filter control. */
  action?: ReactNode;
  className?: string;
}

export function CardHeader({ title, sub, action, className }: CardHeaderProps) {
  return (
    <div className={cx('card-head', className)}>
      <div>
        <div className="card-title">{title}</div>
        {sub && <div className="card-sub">{sub}</div>}
      </div>
      {action}
    </div>
  );
}
